import React, { Component } from 'react';
import { HashRouter, Switch } from 'react-router-dom';

import { allFlattenRoutes as routes } from './index';
import UserManager from '../core/User';
import { subscribe, Keys } from '../core/MessageBus';

// All layouts/containers
import AuthLayout from '../layouts/Auth';
import VerticalLayout from '../layouts/Vertical';

import Loader from '../components/Loader';

export default class Routes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: null,
            isAuthenticated: this.isAuthenticated(),
            userDetails: null,
            messageBus: null,
        };
        this.messageBusSubscriber = subscribe('USER_DETAILS_UPDATED', this.messageBusUpdate);
        this.messageBusSubscriberUnauthorized = subscribe(Keys.HTTP_UNAUTHORIZED_REQUEST, () => {
            this.messageBusUpdate(null);
        });
    }

    componentDidMount() {
        this.setState({
            isAuthenticated: this.isAuthenticated(),
        });
        this.testIfAuthenticated = window.setInterval(() => {
            this.isAuthenticated();
        }, 5000);
    }

    componentWillUnmount() {
        this.messageBusSubscriber.unsubscribe();
        this.messageBusSubscriberUnauthorized.unsubscribe();
        window.clearInterval(this.testIfAuthenticated);
    }

    messageBusUpdate = (data) => {
        this.setState({
            messageBus: data ? { ...data } : null,
        });
    };

    isAuthenticated = () => {
        const result = UserManager.isAuthenticated();
        if (!result && this.state && (this.state.messageBus || this.state.user || this.state.isAuthenticated)) {
            this.setState({
                messageBus: null,
                user: null,
                isAuthenticated: false,
            });
        }
        return result;
    };

    updateUserDetails = () => {
        UserManager.getUserDetails().then((data) => {
            this.setState({
                userDetails: data,
            });
        });
    };

    // returns the layout
    getLayout = () => {
        if (!this.isAuthenticated()) return AuthLayout;

        let layoutCls = VerticalLayout;

        // switch (this.props.layout.layoutType) {
        //     case layoutConstants.LAYOUT_HORIZONTAL:
        //         layoutCls = HorizontalLayout;
        //         break;
        //     case layoutConstants.LAYOUT_DETACHED:
        //         layoutCls = DetachedLayout;
        //         break;
        //     default:
        //         layoutCls = VerticalLayout;
        //         break;
        // }
        return layoutCls;
    };

    shouldComponentUpdate(nextProps, nextState) {
        return (
            this.state.messageBus != nextState.messageBus ||
            this.state.user != nextState.user ||
            this.state.isAuthenticated != nextState.isAuthenticated
        );
    }

    /*shouldComponentUpdate(nextProps, nextState) {
        let oldLayout = { ...this.props.layout };
        delete oldLayout.showRightSidebar;
        let newLayout = { ...nextProps.layout };
        delete newLayout.showRightSidebar;
        return (
            JSON.stringify(oldLayout) !== JSON.stringify(newLayout) ||
            JSON.stringify(this.props.user) !== JSON.stringify(nextProps.user) ||
            this.state.userDetails !== nextState.userDetails ||
            this.state.isAuthenticated != UserManager.isAuthenticated() ||
            this.state.isAuthenticated != nextState.isAuthenticated ||
            (this.state.isAuthenticated && this.state.userDetails == null) ||
            (nextState.isAuthenticated && nextState.userDetails == null)
        );
    }*/

    render() {
        const Layout = this.getLayout();

        if (this.isAuthenticated() && UserManager.getUserDetailsSync() == null) {
            this.updateUserDetails();
            return <Loader />;
        }

        // rendering the router with layout
        return (
            <HashRouter>
                <Layout {...this.props}>
                    <Switch>
                        {routes.map((route, index) => {
                            return (
                                !route.children && (
                                    <route.route
                                        key={index}
                                        path={route.path}
                                        roles={route.roles}
                                        minRoles={route.minRoles}
                                        exact={route.exact}
                                        component={route.component}></route.route>
                                )
                            );
                        })}
                    </Switch>
                </Layout>
            </HashRouter>
        );
    }
}
